import React from 'react';
import _ from "underscore";

import Container from "react-bootstrap/Container";

import config from "../../config";
import Nav from "react-bootstrap/Nav";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import ReactHtmlParser from "react-html-parser"

const MagazineMenu = () => {
    const article_1 = {
        url: `${config.host_rebag_shop}/collections/wishlist-worthy/`,
        title: "Wishlist-Worthy",
        sub_title: "Exceptional pieces that elevate any collection to new heights.",
        image: `${config.MEDIA_URL}/img/gift-guide-2024/wishlist-worthy-nav.jpg`,
        cta_label: "Shop"
    }
    const article_2 = {
        url: `${config.host_rebag_shop}/collections/cant-go-wrong/`,
        title: "Can’t Go Wrong",
        sub_title: "Iconic, timeless items that are always worth the investment.",
        image: `${config.MEDIA_URL}/img/gift-guide-2024/cant-go-wrong-nav.jpg`,
        cta_label: "Shop"
    }

    return (
        <div className="top-nav">
            <Container>
                <Row>
                    <Col xl={{ span: 2, offset: 0 }} lg={{ span: 2, offset: 0 }}>
                        <h4 className="top-nav__nav-title">The Gift Suite</h4>
                        <Nav className="top-nav__nav-list top-nav__gift-links">
                            {_.map(config.gift_collections, (collection, idx) => {
                                return (
                                    <Nav.Item
                                        key={idx}
                                        className={`top-nav__nav-list-item-secondary nav-link nav-top-link`}
                                        as="a"
                                        href={collection.url}
                                    >
                                        {collection.title}
                                    </Nav.Item>
                                );
                            })}
                        </Nav>
                    </Col>
                    <Col xl={5} lg={5}>
                        <MagazineArticle key="article-last" article={article_1} />
                    </Col>
                    <Col xl={5} lg={5}>
                        <MagazineArticle key="article-before-last" article={article_2} />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

const MagazineArticle = ({ article }) => {
    return (
        <div className="top-nav__sale">
            <a href={article.url}>
                <div className="top-nav__sale-img">
                    <img
                        alt={article.title}
                        src={article.header_vault_image || article.image}
                        title={article.title}
                    />
                </div>
                <div className="top-nav__sale-text">
                    <h2 className="top-nav__sale-title top-nav__sale-title--caps">
                        {article.title}
                    </h2>
                    <div className="top-nav__sale-excerpt">{ReactHtmlParser(article.sub_title)}</div>
                    <div className="top-nav__sale-cta">
                        {article.cta_label}
                    </div>
                </div>
            </a>
        </div>
    )
}

export default MagazineMenu;